import { LANGUAGE_SET, LANGUAGE_RESET } from "../actionNames";

const initialState = {
  data: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LANGUAGE_SET:
      return {
        ...state,
        data: action.language,
      };

    case LANGUAGE_RESET:
      return {
        ...state,
        data: undefined,
      };

    default:
      return state;
  }
};
